import { Grid } from '@mui/material';
import NoGraphData from './NoGraphData';
import GroupPieChart from './GroupPieChart';
import GroupBarGraph from './GroupBarGraph';

function GraphPairForGroups({ barGraphData, pieChartData, year, type, unit, companyName, groupArray }) {
    return (
        <NoGraphData data={barGraphData} year={year} type={type} variant={'bar-graph'}>
            <Grid xs={12} xl={6} item display="flex" alignContent={'space-between'}>
                <GroupBarGraph data={barGraphData} year={year} type={type} unit={unit} companyName={companyName} groupArray={groupArray} />
            </Grid>
            <Grid xs={12} xl={6} item display="flex" alignContent={'space-between'}>
                <GroupPieChart data={pieChartData} year={year} type={type} companyName={companyName} unit={unit} />
            </Grid>

        </NoGraphData>

    )
}

export default GraphPairForGroups;